const ExportReportReducer = (state = [], action) => {
    switch (action.type) {
        default:
            return state
    }
}
export default ExportReportReducer